// 渠道类型
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("channelType") || ""
}

const getters = {
  getChannelType:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("channelType",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("channelType")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}